export const ReelIconV2 = ({ width = '25', height = '25' }) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12.5" cy="12.5" r="12.5" fill="white" />
    <path
      d="M17.8714 9.7939C17.8109 9.55204 17.6876 9.33043 17.514 9.15147C17.3404 8.97251 17.1226 8.84252 16.8827 8.77465C16.0062 8.56061 12.5 8.56061 12.5 8.56061C12.5 8.56061 8.99374 8.56061 8.11719 8.79504C7.87728 8.86291 7.65954 8.99289 7.48594 9.17186C7.31235 9.35082 7.18906 9.57242 7.12852 9.81429C6.9681 10.7039 6.88962 11.6063 6.89409 12.5102C6.88837 13.4209 6.96685 14.3302 7.12852 15.2265C7.19526 15.4609 7.32131 15.674 7.4945 15.8454C7.66769 16.0168 7.88216 16.1407 8.11719 16.205C8.99374 16.4394 12.5 16.4394 12.5 16.4394C12.5 16.4394 16.0062 16.4394 16.8827 16.205C17.1226 16.1371 17.3404 16.0071 17.514 15.8282C17.6876 15.6492 17.8109 15.4276 17.8714 15.1857C18.0306 14.3029 18.1091 13.4073 18.1058 12.5102C18.1116 11.5995 18.0331 10.6902 17.8714 9.7939Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3533 14.1767L14.2837 12.5102L11.3533 10.8437V14.1767Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
